import { css } from 'styled-components'

export const SANS_SERIF = css`'Montserrat', -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Arial,
    sans-serif`

export const SERIF = css`'Times New Roman', Georgia, serif`
